(() => {
  const root = document.querySelector('#as-compare');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const t = JSON.parse(root.querySelector('[data-as-translations]').dataset.asTranslations);
  const key = 'as-machine-compare-v1';
  const tray = root.querySelector('.as-compare-tray');
  const sheet = root.querySelector('.as-compare-sheet');
  const view = root.querySelector('.as-compare-view');
  const result = root.querySelector('[data-as-result]');
  const live = root.querySelector('[role=status]');
  let selection = [], products = [], busy = false, generation = 0;
  try { selection = [...new Set(JSON.parse(localStorage.getItem(key)) || [])].filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)).slice(0, 3); } catch {}
  const clean = s => String(s || '').replace(/\s+/g, ' ').trim();
  const norm = s => clean(s).toLowerCase().replace(/[°℃]/g, '').replace(/40\s*c/g, '40c').replace(/\s*:\s*$/, '');
  const el = (tag, text, cls) => { const n = document.createElement(tag); if (text !== undefined) n.textContent = text; if (cls) n.className = cls; return n; };
  const announce = s => { live.textContent = s; };
  const save = () => { try { localStorage.setItem(key, JSON.stringify(selection)); } catch {} };
  const button = (text, action, handle) => { const n = el('button', text); n.type = 'button'; n.dataset[action] = handle || ''; return n; };
  const groups = {
    'machine specifications':'power', 'machine specification':'power', 'mig specifications':'mig',
    'tig specifications':'tig', 'stick specifications':'stick', 'mma specifications':'stick',
    'plasma cut specifications':'plasma', 'plasma specifications':'plasma', 'size and weight':'physical',
    'size & weight':'physical', 'machine features':'technical', 'specifications':'technical',
    'technical specifications':'technical'
  };
  const aliases = {
    'mig current range':'mig welding current range', 'tig current range':'tig welding current range',
    'mma current range':'stick welding current range', 'mma welding current range':'stick welding current range',
    'mma duty cycle @ 40c':'stick duty cycle @ 40c', 'mma electrode range':'stick electrode range',
    'mma welding thickness range':'stick welding thickness range',
    'mig wire sizes':'mig wire size range', 'mig wire spool sizes':'mig wire spool size',
    'warranty (years)':'warranty (years)', 'rated input powr (kva)':'rated input power (kva)'
  };
  const filterRows = [
    ['welder_power_supply','power_supply'], ['welder_process','process'], ['welder_materials','materials'],
    ['welder_tig_type','tig_type'], ['welder_spool_size','spool'], ['welder_features','listed_features'],
    ['plasma_steel_clean_cut','clean_cut']
  ];
  function specifications(p) {
    const doc = new DOMParser().parseFromString(p.description || '', 'text/html');
    const rows = new Map();
    let skipped = 0, count = 0;
    for (const table of doc.querySelectorAll('table')) {
      const trs = [...table.rows];
      if (!trs.some(r => r.cells.length >= 2)) continue;
      if (table.querySelector('table,img,iframe,video,input,button') || trs.some(r => [...r.cells].some(c => c.rowSpan > 1 || (r.cells.length > 1 && c.colSpan > 1))) || trs.some(r => r.cells.length > 2)) { skipped++; continue; }
      let previous = table.previousElementSibling;
      while (previous && !clean(previous.textContent)) previous = previous.previousElementSibling;
      let heading = clean(table.caption?.textContent || (trs[0]?.cells.length === 1 ? trs[0].textContent : ''));
      if (!heading && previous && /specifications?|size.*weight/i.test(previous.textContent) && clean(previous.textContent).length < 100) heading = clean(previous.textContent);
      const group = groups[norm(heading)] || 'technical';
      for (const tr of trs) {
        if (tr.cells.length !== 2 || tr.parentElement.tagName === 'THEAD') continue;
        let label = clean(tr.cells[0].textContent);
        let value = window.ASProductSpecifications.text(tr.cells[1]);
        const canonical = window.ASProductSpecifications.normalize(label, value);
        label = canonical.label; value = canonical.value;
        if (!label || !value || /^(model|configuration|specification|parameter|item)$/i.test(label)) continue;
        if (/^RIL\d/i.test(label)) { skipped++; continue; }
        let id = aliases[norm(label)] || norm(label);
        if (/^(mig|tig|stick|plasma) duty cycle @ 40\s*c$/.test(id)) id = id.replace(/40\s*c$/, '40c');
        const process = id.match(/^(mig|tig|stick|plasma)\s/);
        const rowGroup = process ? process[1] : /^(dimensions? \(mm\)|weight \(kg\))$/.test(id) ? 'physical' : /^(primary input voltage|supply plug|ieff \(a\)|insulation class|minimum generator \(kva\)|no load voltage \(v\)|protection class|rated output|standard|suitable material|warranty \(years\))$/.test(id) ? 'power' : group;
        const identity = 'spec:' + rowGroup + ':' + id;
        const existing = rows.get(identity);
        if (existing && existing.value !== value) { existing.value = null; existing.conflict = true; continue; }
        if (!existing) { rows.set(identity, {id:identity, label, value, group:rowGroup}); count++; }
      }
    }
    for (const [field, label] of filterRows) {
      const values = p.filters?.[field];
      if (Array.isArray(values) && values.length) rows.set('filter:' + field, {id:'filter:' + field, label:t[label], value:values.join(', '), group:'buying'});
    }
    p.rows = rows; p.skipped = skipped; p.tableCount = count;
    return p;
  }
  async function load(handle) {
    const url = new URL(root.dataset.root + 'products/' + handle, location.origin);
    url.searchParams.set('view', 'as-compare');
    if (root.dataset.preview === 'true') url.searchParams.set('preview_theme_id', root.dataset.theme);
    const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
    if (!response.ok) throw new Error(t.load_error);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const payload = doc.querySelector('[data-as-compare-payload]')?.dataset.asComparePayload;
    if (!payload) throw new Error(t.load_error);
    const p = JSON.parse(payload);
    if (p.handle !== handle || !p.machine) throw new Error(t.load_error);
    return specifications(p);
  }
  const currentVariant = p => p.variants.find(v => v.id === p.chosenVariant) || p.variants.find(v => v.id === p.defaultVariant) || p.variants[0];
  function item(handle) {
    const p = products.find(p => p.handle === handle);
    const title = p?.title || document.querySelector('[data-as-compare-select="' + handle + '"]')?.dataset.asTitle || handle;
    const n = el('div', undefined, 'as-compare-item');
    if (p?.image) { const img = el('img'); img.src = p.image; img.alt = ''; n.append(img); }
    n.append(el('span', title), button(t.remove, 'asRemove', handle));
    n.lastChild.setAttribute('aria-label', t.remove + ' ' + title);
    return n;
  }
  function sync() {
    tray.hidden = !selection.length;
    document.body.classList.toggle('as-compare-has-selection', !!selection.length);
    root.querySelector('[data-as-open-sheet]').textContent = t.compare + ' (' + selection.length + '/3) ↑';
    for (const node of root.querySelectorAll('[data-as-tray-items],[data-as-sheet-items]')) node.replaceChildren(...selection.map(item));
    for (const b of root.querySelectorAll('[data-as-open]')) { b.disabled = selection.length < 2 || busy; b.textContent = t.compare + ' (' + selection.length + '/3)'; }
    for (const b of document.querySelectorAll('[data-as-compare-select]')) {
      b.hidden = false;
      const selected = selection.includes(b.dataset.asCompareSelect);
      b.setAttribute('aria-pressed', String(selected));
      b.setAttribute('aria-label', (selected ? t.selected : t.select) + ': ' + b.dataset.asTitle);
      b.querySelector('[data-as-control-label]').textContent = selected ? t.selected : t.select;
      b.querySelector('[aria-hidden]').textContent = selected ? '✓' : '□';
    }
  }
  function close(dialog) { dialog.close(); document.body.classList.toggle('as-compare-modal', !!root.querySelector('dialog[open]')); }
  function open(dialog) { if (!dialog.open) dialog.showModal(); document.body.classList.add('as-compare-modal'); }
  function headerCell(p) {
    const cell = el('th'); cell.scope = 'col';
    if (p.image) { const img = el('img', undefined, 'as-compare-product-image'); img.src = p.image; img.alt = ''; cell.append(img); }
    const link = el('a', p.title, 'as-compare-product-title'); link.href = p.url; cell.append(link);
    const v = currentVariant(p);
    if (p.variants.length > 1) {
      const select = el('select'); select.dataset.asVariant = p.handle; select.setAttribute('aria-label', t.options + ': ' + p.title);
      for (const variant of p.variants) { const option = el('option', variant.title); option.value = variant.id; option.selected = variant.id === v.id; select.append(option); } cell.append(select);
    }
    if (v) {
      cell.append(el('small', v.sku), el('span', v.price, 'as-compare-price'), el('span', t[v.stock], 'as-compare-stock'));
      if (p.requiresSellingPlan || p.variantCount > p.variants.length) { const link = el('a', t.view_product); link.href = p.url; cell.append(link); }
      else { const add = button(t.add, 'asAdd', p.handle); add.className = 'as-compare-primary'; add.disabled = !v.available; cell.append(add); }
    }
    const remove = button(t.remove, 'asRemove', p.handle); remove.setAttribute('aria-label', t.remove + ' ' + p.title); cell.append(remove);
    if (p.variants.length > 1) cell.append(el('small', t.variants_note));
    return cell;
  }
  function differs(values) {
    return new Set(values.map(v => v == null ? '__missing__' : norm(v).replace(/[–−—]/g, '-').replace(/\b(single|three)[ -]+phase\b/g, '$1 phase').replace(/(\d)\s+(mm|kg|a|v|hz|kva|kw)\b/g, '$1$2').replace(/(\d)\s*-\s*(?=\d)/g, '$1-'))).size > 1;
  }
  function table(rows, purchase, grouped = true) {
    const scroll = el('div', undefined, 'as-compare-scroll'); scroll.tabIndex = 0; scroll.setAttribute('role','region'); scroll.setAttribute('aria-label', purchase ? t.key_differences : t.all_specs);
    const table = el('table', undefined, 'as-compare-table'); table.style.setProperty('--as-columns', products.length);
    const caption = el('caption', purchase ? t.key_differences : t.all_specs, 'visually-hidden'); table.append(caption);
    const head = el('thead'), hr = el('tr'); const blank = el('th', purchase ? t.key_differences : t.all_specs); blank.scope = 'col'; hr.append(blank);
    for (const p of products) {
      if (purchase) hr.append(headerCell(p));
      else { const th = el('th', p.title); th.scope = 'col'; hr.append(th); }
    }
    head.append(hr); table.append(head);
    const body = el('tbody');
    let previous = '';
    for (const row of rows) {
      const values = products.map(p => row.id === 'price' ? currentVariant(p)?.price : row.id === 'stock' ? t[currentVariant(p)?.stock] : p.rows.get(row.id)?.value);
      const different = differs(values);
      if (root.querySelector('[data-as-differences]').checked && !different) continue;
      if (!purchase && grouped && previous !== row.group) { const group = el('tr', undefined, 'as-compare-group'); const th = el('th', t[row.group] || row.group); th.colSpan = products.length + 1; group.append(th); body.append(group); previous = row.group; }
      const tr = el('tr', undefined, different ? 'as-compare-row-different' : '');
      const label = el('th', row.label); label.scope = 'row'; tr.append(label);
      for (const value of values) tr.append(el('td', value == null ? t.not_listed : value));
      body.append(tr);
    }
    if (!body.children.length) { const tr = el('tr'); const td = el('td', t.no_differences); td.colSpan = products.length + 1; tr.append(td); body.append(tr); }
    table.append(body); scroll.append(table); return scroll;
  }
  function render() {
    if (products.length < 2) { result.replaceChildren(el('p', t.choose_more)); return; }
    const expanded = new Map([...result.querySelectorAll('details[data-as-group]')].map(d => [d.dataset.asGroup,d.open]));
    const union = new Map();
    for (const p of products) for (const [id, row] of p.rows) if (!union.has(id)) union.set(id,row);
    const groupOrder = ['buying','power','technical','features','physical','mig','tig','stick','plasma'];
    const rows = [...union.values()].sort((a,b) => groupOrder.indexOf(a.group) - groupOrder.indexOf(b.group) || a.label.localeCompare(b.label));
    const headline = rows.filter(r => r.group === 'buying' || /current range|supply plug|input voltage|weight|warranty|spool gun|power factor|maximum output|laser output/.test(r.id));
    const differing = headline.filter(r => differs(products.map(p => p.rows.get(r.id)?.value)));
    result.replaceChildren(table([{id:'price',label:t.price},{id:'stock',label:t.stock},...differing], true));
    if (products.some(p => p.skipped)) result.append(el('p', t.partial, 'as-compare-note'));
    if (products.some(p => !p.tableCount)) result.append(el('p', t.no_tables, 'as-compare-note'));
    result.append(el('h3', t.all_specs, 'as-compare-details-heading'));
    const mobile = window.matchMedia('(max-width:749px)').matches;
    for (const group of groupOrder) {
      const sectionRows = rows.filter(row => row.group === group);
      if (!sectionRows.length) continue;
      const details = el('details', undefined, 'as-compare-spec-section');
      details.dataset.asGroup = group;
      details.open = expanded.has(group) ? expanded.get(group) : !mobile || group === 'buying' || group === 'power';
      details.append(el('summary', t[group] || group),table(sectionRows,false,false));
      result.append(details);
    }
  }
  async function refresh(openView) {
    const token = ++generation;
    busy = true; sync();
    if (openView) { close(sheet); open(view); result.replaceChildren(el('p',t.loading)); }
    const handles = [...selection];
    const loaded = await Promise.allSettled(handles.map(load));
    if (token !== generation) return;
    const failed = loaded.some(r => r.status === 'rejected');
    products = loaded.filter(r => r.status === 'fulfilled').map(r => r.value);
    busy = false; sync();
    if (failed && openView) { result.replaceChildren(el('p', t.load_error), button(t.retry,'asRetry')); }
    else if (openView) render();
  }
  function remove(handle) {
    selection = selection.filter(h => h !== handle); products = products.filter(p => p.handle !== handle); generation++; busy = false; save(); sync();
    if (view.open) render();
    if (!selection.length && sheet.open) close(sheet);
  }
  document.addEventListener('click', async event => {
    const b = event.target.closest('button');
    if (!b) return;
    if (b.matches('[data-as-compare-select]')) {
      const handle = b.dataset.asCompareSelect;
      if (selection.includes(handle)) { remove(handle); return; }
      if (selection.length === 3) { announce(t.limit); open(sheet); return; }
      selection.push(handle); save(); sync(); announce(selection.length + '/3 ' + t.count); refresh(false); return;
    }
    if (!root.contains(b)) return;
    if (b.matches('[data-as-remove]')) { remove(b.dataset.asRemove); return; }
    if (b.matches('[data-as-clear]')) { selection = []; products = []; generation++; busy = false; save(); sync(); if (sheet.open) close(sheet); if (view.open) close(view); return; }
    if (b.matches('[data-as-close]')) { close(b.closest('dialog')); return; }
    if (b.matches('[data-as-open-sheet]')) { open(sheet); return; }
    if (b.matches('[data-as-open],[data-as-retry]')) { refresh(true); return; }
    if (b.matches('[data-as-add]')) {
      const p = products.find(p => p.handle === b.dataset.asAdd), v = currentVariant(p);
      if (!v?.available) return;
      b.disabled = true;
      try {
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender?.().map(section => section.id) || ['cart-icon-bubble'];
        const payload = {items:[{id:v.id,quantity:1}],sections,sections_url:location.pathname};
        const response = await fetch(root.dataset.cart + '.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        const cartData = await response.json();
        if (!response.ok || cartData.status) throw new Error();
        if (drawer && sections.every(section => typeof cartData.sections?.[section] === 'string')) {
          close(view);
          drawer.setActiveElement?.(root.querySelector('[data-as-open-sheet]')?.offsetParent ? root.querySelector('[data-as-open-sheet]') : tray.querySelector('[data-as-open]'));
          drawer.classList.remove('is-empty');
          try { drawer.renderContents({...cartData,id:v.id}); } catch {}
        } else if (cartData.sections?.['cart-icon-bubble']) {
          const doc = new DOMParser().parseFromString(cartData.sections['cart-icon-bubble'],'text/html');
          const icon = document.querySelector('#cart-icon-bubble');
          if (icon) icon.innerHTML = doc.querySelector('.shopify-section')?.innerHTML || cartData.sections['cart-icon-bubble'];
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate,{source:'as-compare',productVariantId:v.id,cartData})).catch(() => {});
        b.textContent = t.added; announce(t.added + ': ' + p.title);
        const link = el('a', t.view_cart); link.href = root.dataset.cartPage; b.after(link);
      } catch { b.textContent = t.cart_error; announce(t.cart_error); }
      finally { b.disabled = !v.available; }
    }
  });
  root.addEventListener('change', event => {
    if (event.target.matches('[data-as-differences]')) render();
    if (event.target.matches('[data-as-variant]')) { const p = products.find(p => p.handle === event.target.dataset.asVariant); p.chosenVariant = event.target.value; render(); }
  });
  for (const dialog of [sheet, view]) {
    dialog.addEventListener('close', () => document.body.classList.toggle('as-compare-modal', !!root.querySelector('dialog[open]')));
    dialog.addEventListener('click', e => { if (e.target === dialog) { const rect = dialog.getBoundingClientRect(); if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) close(dialog); } });
  }
  new MutationObserver(records => { if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches('[data-as-compare-select]') || n.querySelector('[data-as-compare-select]'))))) sync(); }).observe(document.querySelector('#MainContent') || document.body, {childList:true,subtree:true});
  sync();
  if (selection.length) refresh(false);
})();

